<style lang="scss" scoped>
  .icon {}
</style>


<template>
  <div class="icon">
    <font-awesome-icon :icon="iconParts"/>
  </div>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { faHdd } from '@fortawesome/free-regular-svg-icons';
import {
  faHdd,
  faKey,
  faQuestionCircle,
  faChartArea,
  faChevronDown,
  faTimes,
  faUserShield,
  faServer,
  faDownload
} from '@fortawesome/free-solid-svg-icons';


library.add(faHdd);
library.add(faKey);
library.add(faQuestionCircle);
library.add(faChartArea);
library.add(faChevronDown);
library.add(faTimes);
library.add(faUserShield);
library.add(faServer);
library.add(faDownload);


export default {
  name: 'icon',
  props: {
    icon: {
        type: String,
        required: true
      },
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    iconParts() {
      const parts = this.icon.split(/-(.+)/);
      return [parts[0], parts[1]];
    }
  }
};
</script>
